module.exports = __webpack_public_path__ + "static/media/hm.9a095a09.svg";